<template>
  <pt-integral-exchange class="pt-integral-exchange__page"></pt-integral-exchange>
</template>

<script>
import PtIntegralExchange from 'cps//integral-mall-manage/pt-integral-exchange/withData'
export default {
  name: 'pt-integral-exchange__view',
  components: {
    'pt-integral-exchange': PtIntegralExchange
  }
}
</script>
